import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const Home = () => {
  const { isAuthenticated, loading, user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // If authentication check is complete
    if (!loading) {
      if (isAuthenticated) {
        // Log user data for debugging
        console.log('User data in Home component:', user);
        
        // Redirect based on user role - handle different possible structures
        if (user) {
          // Check different possible locations of the role property
          const role = user.role || 
                      (user.data && user.data.role) || 
                      (typeof user === 'string' ? null : null);
          
          console.log('Detected role:', role);
          
          if (role) {
            switch (role.toLowerCase()) {
              case 'administrator':
                navigate('/admin');
                break;
              case 'manager':
                console.log('Redirecting to manager dashboard');
                navigate('/audit/my-cases');
                break;
              case 'reviewer':
                navigate('/audit/reviewer');
                break;
              default:
                navigate('/admin');
            }
          } else {
            // If we can't determine the role, redirect to user-debug
            console.log('Could not determine user role, redirecting to debug');
            navigate('/user-debug');
          }
        } else {
          // Default redirect if no user data
          console.log('No user data, redirecting to admin');
          navigate('/admin');
        }
      } else {
        // Redirect to login if not authenticated
        navigate('/login');
      }
    }
  }, [isAuthenticated, loading, user, navigate]);

  // Show loading while checking authentication
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Loading...
      </Typography>
    </Box>
  );
};

export default Home;
